import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigurationOptionType, EgiRoutes } from '@ervo/page-framework';
import { ExternalUrlPageComponent } from './external-url-page/external-url-page.component';
import { SharedModule } from '@shared/shared.module';

const topic = 'External';

@NgModule({
  declarations: [ExternalUrlPageComponent],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class ExternalPagesModule {
  static readonly routes: EgiRoutes = [
    {
      path: 'external-url',
      component: ExternalUrlPageComponent,
      data: {
        config: {
          id: 'f7835227-cdd4-4fc2-bfa3-59a6eaf4a97a',
          features: {},
          topic,
          name: 'Externe pagina',
          configurationOptions: {
            url: {
              type: ConfigurationOptionType.URL,
              required: true,
              showValueInBreadCrumb: true
            },
            openInExternalTab: {
              type: ConfigurationOptionType.Boolean,
              required: false,
              showValueInBreadCrumb: false
            }
          }
        }
      }
    }
  ];
}
